import { useState } from "react"

export function useForm() {
  const [search, setSearch] = useState("")

  return { search, setSearch }
}
